import React from "react";
import styled from "styled-components";

import { SkyLightStateless } from "react-skylight";
import { styles } from "../menu/styles";
import Header from "../header";
import { PrintComponent } from "./PrintComponent";

const HeaderContainer = styled.div`
  display: flex;
`;

export const PrintDialog = ({ paper, title, onClose }) => {
  return (
    <div>
      <SkyLightStateless
        isVisible={true}
        dialogStyles={styles.defaultDialogStyles}
        onCloseClicked={onClose}
        onOverlayClicked={onClose}
        title={
          <HeaderContainer>
            <Header title={title || "Print"} />
          </HeaderContainer>
        }
      >
        <PrintComponent paper={paper} />
      </SkyLightStateless>
    </div>
  );
};
